import { combineReducers } from 'redux'
import { routerReducer as routing } from 'react-router-redux'
import { merge } from 'lodash'

import auth from 'features/Auth/Auth.reducer'
import layout from 'features/Layout/Layout.reducer'
import storeReducer from 'features/Store/Store.reducer'
import analytics from 'features/Analytics/Analytics.reducer'
import modal from 'features/Modal/Modal.reducer'
import scroll from 'components/Scroll/Scroll.reducer'
import toasts from 'features/Toasts/Toasts.reducer'
import addToHome from 'features/AddToHome/AddToHome.reducer'
import cms from 'features/Cms/Cms.reducer'
import billing from 'features/Billing/Billing.reducer'
import numbers1300 from 'features/Numbers1300/Numbers1300.reducer'
import numbers1800 from 'features/Numbers1800/Numbers1800.reducer'
import files from 'features/Files/Files.reducer'
import cases from 'features/Cases/Cases.reducer'
import numbers from 'features/Numbers/Numbers.reducer'
import flows from 'features/Flows/Flows.reducer'
import users from 'features/Users/Users.reducer'
import phoneSystem from 'features/PhoneSystem/PhoneSystem.reducer'
import { contactsReducer as contacts } from 'features/Contacts/Contacts.reducer'
import { recordingsReducer as recordings } from 'features/Recordings/Recordings.reducer'
import { voicesReducer as voices } from 'features/Voices/Voices.reducer'
import { hostedVoiceReducer as hostedVoice } from 'features/Services/HostedVoice/HostedVoice.reducer'
import { reducer as form } from 'redux-form'

const splitReducers = combineReducers({
  addToHome,
  analytics,
  auth,
  cases,
  contacts,
  cms,
  billing,
  flows,
  form,
  layout,
  modal,
  routing,
  scroll,
  toasts,
  numbers,
  numbers1300,
  numbers1800,
  files,
  users,
  phoneSystem,
  recordings,
  voices,
  services: combineReducers({
    hostedVoice,
  }),
})

export default (state, action) => {
  if (action.type === 'MERGE_INITIAL_STATE') {
    return merge({}, state, action.payload)
  }
  const isStoreAction = action && action.type && action.type.startsWith('STORE/')
  return isStoreAction
    ? splitReducers(storeReducer(state, action), action)
    : splitReducers(state, action)
}



// WEBPACK FOOTER //
// ./src/app/reducer.js